module.exports = __webpack_public_path__ + "static/media/Wesam.e4a7f4f1.jpeg";